import chroma, { Color } from 'chroma-js';

export const rgba = (color: Color | string) => {
  if (typeof color === 'string') color = chroma(color);
  const [r, g, b, a] = color.rgba();
  return `rgba(${r},${g},${b},${a})`;
};
